import { MaskLine, Reveal } from "./Motion";

const CATEGORIES = [
  {
    numeral: "I",
    name: "Inovação em Licitações",
    criteria: "Tecnologia, inteligência artificial, automação e novos métodos aplicados à contratação pública.",
  },
  {
    numeral: "II",
    name: "Sustentabilidade nas Contratações",
    criteria: "Critérios ambientais, sociais e de governança (ESG) com impacto mensurável nos certames.",
  },
  {
    numeral: "III",
    name: "Gestão e Resultados",
    criteria: "Eficiência administrativa, economia de recursos públicos e processos com resultados comprovados.",
  },
];

export default function Premio({ onInscrever }) {
  return (
    <section
      id="premio"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(160deg, #1C0E05 0%, #2B1608 55%, #160B05 100%)" }}
      data-testid="premio-section"
    >
      {/* Foto do palco de premiação · fundo à direita, imagem inteira sem corte */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute inset-y-0 right-0 w-full lg:w-[62%] flex items-center justify-end">
          <img
            src="/premio-palco.jpg"
            alt=""
            className="max-h-full w-auto max-w-full object-contain opacity-45 lg:opacity-80"
          />
        </div>
        {/* degradê suave para legibilidade do texto à esquerda */}
        <div
          className="absolute inset-0"
          style={{ background: "linear-gradient(90deg, #1C0E05 15%, rgba(28,14,5,0.78) 42%, rgba(22,11,5,0.28) 62%, rgba(22,11,5,0.05) 80%)" }}
        />
      </div>

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="max-w-2xl">
          <h2 className="font-serif font-semibold text-[#F6EBD7] text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.06] tracking-tight" data-testid="premio-heading">
            <MaskLine inView>Prêmio CEAP BRASIL</MaskLine>
            <MaskLine inView delay={0.12}>
              de <span className="italic text-[#E8C37A]">Excelência em Licitações</span>
            </MaskLine>
          </h2>

          <Reveal delay={0.2}>
            <p className="mt-6 text-[#E6D7BC]/85 text-base sm:text-lg leading-relaxed max-w-xl">
              Nosso objetivo é um só: colocar o servidor de licitações no centro do palco, onde ele sempre mereceu
              estar. Inscreva o case do seu órgão e transforme o seu trabalho em referência nacional.
            </p>
          </Reveal>

          {/* Categorias · numerais romanos editoriais */}
          <Reveal delay={0.28}>
            <ul className="mt-10 border-t border-[#D9A441]/25" data-testid="premio-categories">
              {CATEGORIES.map((c) => (
                <li key={c.numeral} className="flex gap-5 py-5 border-b border-[#D9A441]/25" data-testid={`premio-cat-${c.numeral}`}>
                  <span className="font-serif italic font-semibold text-[#D9A441] text-2xl leading-none w-10 shrink-0 pt-0.5">
                    {c.numeral}
                  </span>
                  <div>
                    <h3 className="font-display font-bold text-[#F6EBD7] text-base sm:text-lg">{c.name}</h3>
                    <p className="mt-1 text-sm text-[#E6D7BC]/65 leading-relaxed">{c.criteria}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.34}>
            <p className="mt-7 font-sans text-sm font-semibold text-[#D9A441]">
              Inscrições até 20 de janeiro de 2027 · Premiação no palco em 04 de março de 2027
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-4">
              <button
                onClick={onInscrever}
                className="inline-flex items-center justify-center px-9 py-4 rounded-full font-display font-bold uppercase tracking-[0.06em] text-sm text-[#241209] transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: "linear-gradient(92deg, #E8C37A 0%, #D9A441 100%)", boxShadow: "0 14px 40px rgba(217,164,65,0.35)" }}
                data-testid="premio-cta"
              >
                Inscreva seu case
              </button>
              <a
                href="/edital-premio-ceap-2027.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-9 py-4 rounded-full font-display font-bold uppercase tracking-[0.06em] text-sm text-[#E8C37A] border border-[#D9A441]/50 hover:border-[#E8C37A] hover:bg-[#D9A441]/10 transition-all duration-300"
                data-testid="premio-edital-btn"
              >
                Baixar edital do prêmio
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
